<button
  matButton="outlined"
  type="button"
  class="px-4 py-3 w-full entra-login-button"
  (click)="buttonClick.emit()"
  [matTooltip]="'AUTH.LOGIN.entra_button' | translate"
>
  <span class="entra-login-button__content">
    <span class="entra-login-button__icon" aria-hidden="true">
      <img
        src="assets/icons/entra-logo.svg"
        alt=""
        class="entra-login-button__icon-image"
      />
    </span>
    <span>{{ 'AUTH.LOGIN.entra_button' | translate }}</span>
  </span>
</button>
